import './LogInFlow.scss';

import React, { useRef, useState } from 'react';

import LoginModal from '../LoginModal/LoginModal';
import ModalDialog from '../modals/ModalDialog/ModalDialog';
import VerifyAccount from '../VerifyAccount/VerifyAccount';

const LogInFlow = (props) => {
  const { modalRef } = props;
  const [accessToken, getAccessToken] = useState('');
  const [registerData, getRegisterData] = useState();
  const verifyModalRef = useRef(null);

  const closeModal = (ref) => {
    ref.current.closeModal();
  };

  const openModal = (ref) => {
    ref.current.openModal();
  };

  return (
    <div>
      <ModalDialog ref={modalRef} className="loginModal">
        <LoginModal
          closeModal={closeModal}
          openModal={openModal}
          modalRef={modalRef}
          verifyModalRef={verifyModalRef}
          getAccessToken={getAccessToken}
          getRegisterData={getRegisterData}
        />
      </ModalDialog>
      <ModalDialog ref={verifyModalRef}>
        <VerifyAccount
          closeModal={closeModal}
          modalRef={verifyModalRef}
          accessToken={accessToken}
          registerData={registerData}
        />
      </ModalDialog>
    </div>
  );
};

export default LogInFlow;
